import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, RotateCcw, Target, Sparkles, Shield } from 'lucide-react';
const audiences = [{
  icon: Briefcase,
  title: 'Personas ocupadas',
  desc: 'Sin tiempo para pasar horas en un gimnasio.'
}, {
  icon: RotateCcw,
  title: 'Ya intentaron antes',
  desc: 'Necesitan un método simple que puedan mantener.'
}, {
  icon: Target,
  title: 'Principiantes',
  desc: 'Quieren empezar sin sentirse intimidados.'
}, {
  icon: Sparkles,
  title: 'Verse y sentirse mejor',
  desc: 'Más energía, confianza y mejores hábitos.'
}, {
  icon: Shield,
  title: 'Disciplina real',
  desc: 'Sin métodos extremos ni presión innecesaria.'
}];
export function ForWhom() {
  return <section className="py-10 md:py-20 px-4 bg-zinc-900/30" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <div className="text-center mb-6 md:mb-12" data-id="element-90">
          <h2 className="text-4xl md:text-6xl font-bebas text-white mb-2" data-id="element-91">
            ¿PARA QUIÉN ES?
          </h2>
          <p className="text-sm md:text-xl text-zinc-400" data-id="element-92">
            Diseñado para personas reales que quieren transformarse desde casa
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-2.5 md:gap-6" data-id="element-93">
          {audiences.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} whileHover={{
          y: -4
        }} whileTap={{
          scale: 0.97
        }} className={`bg-zinc-900 border border-zinc-800 p-3 md:p-6 rounded-xl md:rounded-2xl hover:border-brand-500/50 transition-colors group cursor-pointer ${i === 4 ? 'col-span-2 md:col-span-1' : ''}`} data-id="element-94">
              <div className="w-9 h-9 md:w-12 md:h-12 bg-zinc-800 rounded-lg md:rounded-xl flex items-center justify-center mb-2 md:mb-4 group-hover:bg-brand-500/20 transition-colors" data-id="element-95">
                <item.icon className="w-4 h-4 md:w-6 md:h-6 text-zinc-400 group-hover:text-brand-500 transition-colors" data-id="element-96" />
              </div>
              <h3 className="font-bold text-white text-sm md:text-xl mb-1 md:mb-2 leading-tight" data-id="element-97">
                {item.title}
              </h3>
              <p className="text-zinc-400 text-xs md:text-sm leading-snug" data-id="element-98">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}